import { useEffect } from 'react';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import { selectedCurrencyVar } from '../../graphql/cache';
import useCustomerStorage from '../../../common/hooks/useCustomerStorage';

interface IUsePersistedCurrencyPreferenceReturn {
  isSecondaryCurrencyDisplay: boolean;
}

export const usePersistedCurrencyPreference: () => IUsePersistedCurrencyPreferenceReturn = () => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const { primary, secondary } = priceDisplay;
  const { customerStorage } = useCustomerStorage();
  const isSecondaryCurrencyDisplay =
    primary.currency !== secondary?.currency && secondary?.currency === selectedCurrencyVar();
  const customerData = customerStorage.getCustomerData();

  useEffect(() => {
    // Check on load for existing currency preference.
    selectedCurrencyVar(customerData?.selectedCurrency || primary?.currency);
  }, [customerData, primary]);

  useEffect(() => {
    // Persist selected currency on local storage on currency change.
    customerData.selectedCurrency = selectedCurrencyVar();
    customerStorage.setCustomerData(customerData);
  }, [isSecondaryCurrencyDisplay]);

  return { isSecondaryCurrencyDisplay };
};
